module.exports = __webpack_public_path__ + "img/20.7e9639b4.jpg";